import _ from "underscore";
import MeEndpoints from "../api/me/MeEndpoints";
import Me from "../store/modules/me/model/Me";
import User from "../store/user/model/User";
import UserEndpoints from "../api/user/UserEndpoints";
import Client from "../store/modules/client/model/Client";
import ClientEndpoints from "../api/client/ClientEndpoints";
import Session from "js/Session";

const EXTOLE_CLIENT_ID = "1890234003";

function fetchMe() {
    return new Promise((resolve) => {
        MeEndpoints.get().done((meResponse) => {
            resolve(new Me(meResponse));
        });
    });
}
function fetchClient(clientId) {
    return ClientEndpoints.getClient(clientId).then((clientResponse) => {
        return new Client(clientResponse.data);
    });
}
function fetchUser(userId) {
    return new Promise((resolve) => {
        UserEndpoints.get(userId).done((userResponse) => {
            resolve(new User(userResponse));
        });
    });
}

async function fetchData() {
    const me = await fetchMe();

    const [myClient, myUser] = await Promise.all([
        fetchClient(me.client_id),
        fetchUser(me.user_id),
    ]);

    return {
        me,
        myUser,
        myClient,
    };
}

const initializeIntercom = async () => {
    const isSuperUser = Session.getInstance().isSuperUser();
    const data = await fetchData();

    const id = data.myUser.user_id;
    const { email, intercom_user_hash } = data.me;
    const fullName = data.myUser.getFullName();

    const company = {
        company_id: data.myClient.client_id,
        name: data.myClient.name,
    };
    if (isSuperUser) {
        company.company_id = EXTOLE_CLIENT_ID;
        company.name = "Extole";
    }

    window.intercomSettings = {
        api_base: "https://api-iam.intercom.io",
        app_id: "syy27wia",
        user_id: id,
        name: fullName ?? undefined,
        email: email,
        user_hash: intercom_user_hash,
        company,
    };
};

const bootstrap = _.once(async function () {
    await initializeIntercom();
    const settings = `(function () {
        const w = window;
        const ic = w.Intercom;
        if (typeof ic === "function") {
            ic("reattach_activator");
            ic("update", w.intercomSettings);
        } else {
            const d = document;
            const i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            const l = function () {
                const s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://widget.intercom.io/widget/syy27wia";
                const x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === "complete") {
                l();
            } else if (w.attachEvent) {
                w.attachEvent("onload", l);
            } else {
                w.addEventListener("load", l, false);
            }
        }
    })();`;
    const scriptTag = document.createElement("script");

    scriptTag.textContent = settings;
    document.head.appendChild(scriptTag);
    setTimeout(() => {
        initializeCloseButton();
    }, 1000);
});

const initializeCloseButton = () => {
    const closeButton = document.createElement("i");
    const intercomWrapper = document.querySelector(
        ".intercom-lightweight-app-launcher"
    );
    closeButton.className = "fa-solid fa-times chat-bot-close-button";
    intercomWrapper.appendChild(closeButton);
    closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.Intercom) {
            window.Intercom("update", {
                hide_default_launcher: true,
            });
            window.Intercom("hide");
        }
    });
};

export default {
    bootstrap,
};
